import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useLayoutEffect, useState } from 'react';

import { useQueryDre } from 'pages/financeiro/dre/hooks';
import { DreForm } from 'pages/financeiro/dre/types';

type DreFormStatus = 'SAVING' | 'RECALCULATING' | null;

export type DreFormContext = {
    dre: DreForm;
    setDre: Dispatch<SetStateAction<DreForm>>;

    dreStatus: number | null;
    setDreStatus: Dispatch<SetStateAction<number | null>>;

    status: DreFormStatus;
    setStatus: Dispatch<SetStateAction<DreFormStatus>>;

    isError: boolean;
    isFetching: boolean;
    error: unknown;
};

const DreFormContext = createContext<DreFormContext>({} as DreFormContext);

export function DreFormProvider({ children }: { children: ReactNode }) {
    const [dre, setDre] = useState<DreForm>({} as DreForm);
    const [status, setStatus] = useState<DreFormStatus>(null);
    const [dreStatus, setDreStatus] = useState<number | null>(null);

    const { isFetching, isError, error, data } = useQueryDre();

    useLayoutEffect(() => {
        if (typeof data === 'object') {
            setDre(data.data.data);
            setDreStatus(data.status);
        }
    }, [data]);

    return (
        <DreFormContext.Provider
            value={{
                dre,
                setDre,
                dreStatus,
                setDreStatus,
                isFetching,
                isError,
                error,
                status,
                setStatus,
            }}
        >
            {children}
        </DreFormContext.Provider>
    );
}

export const useDreFormContext = (): DreFormContext => useContext(DreFormContext);
